import BaseGhostButton from "../../../components/general/BaseGhostButton"
import BaseText from "../../../components/general/BaseText"
import { Quote } from "lucide-react"
import { ImageType } from "../../../types/index"
import BaseHeadline from "../../../components/general/BaseHeadline"

type TClientReviewCard = {
    reviewText: string
    clientLogo?: ImageType
    url: string
    location?: string
    personName?: string
    personPositon?: string
    company?: string
}

export default function ReviewCard(props: TClientReviewCard) {
    return (
        <div className="max-w-xl flex flex-col rounded-xl lg:px-6 justify-center relative">
            <div className="flex-1 flex lg:justify-center relative py-2 ">
                <div className="absolute -top-1 left-2 lg:left-10 z-5 ">
                    <Quote size={80} strokeWidth={1} className="text-secondary/30" />
                </div>

                <BaseText
                    text={`"${props.reviewText}"`}
                    classProps="lg:px-8 max-w-md lg:max-w-lg z-10"
                    textSize="text-xl md:text-2xl font-semibold"
                />
            </div>

            <div className="lg:px-10 max-w-md lg:max-w-7xl">
                <BaseHeadline
                    headline={props.personName}
                    headlineClassProps="!pb-0 text-base-content"
                    text={`${props.personPositon}, ${props.company} - ${props.location}`}
                    tag="h6"
                />
            </div>
            <BaseGhostButton text="Zum Projekt" url={props.url} classProps="flex text-lg pt-6 mb-6 md:mb-12 lg:px-10" />
        </div>
    )
}
